import { Endpoint } from '../endpoint';
import { CompanyId } from '@business/entities/companies';
import { GroupId, GroupResponse } from '@business/entities/group';
import { PermissionResponse } from '@business/entities/permission';
import { TopMenuResponse } from '@business/entities/top_menu';

export function fetchGroups(companyId: CompanyId, isCompact?: boolean, filter?: string) {
  return Endpoint.get<GroupResponse[]>(`@makh/groups`, { params: { companyId, isCompact, filter } });
}

export function fetchPermissions() {
  return Endpoint.get<PermissionResponse[]>(`@makh/groups/all-permissions`);
}

export function fetchAssignedPermissions(groupId: GroupId) {
  return Endpoint.get<PermissionResponse[]>(`@makh/groups/assign-permissions/${groupId}`);
}

export function fetchAssignedLikePermissions(groupId: GroupId, moduleName: string) {
  return Endpoint.get<PermissionResponse[]>(`@makh/groups/assign-like-permissions/${groupId}`, { params: { name: moduleName } });
}

export function fetchAllAssignedPermissions(groupId: GroupId) {
  return Endpoint.get<TopMenuResponse[]>(`@makh/groups/all-assigned-permissions/${groupId}`);
}

export function assignPermissions(data: any) {
  return Endpoint.post<PermissionResponse[]>(`@makh/groups/assign-permissions`, { data });
}

export function updateRolePermission(groupId: GroupId, data: any) {
  return Endpoint.post<PermissionResponse[]>(`@makh/groups/update-role-permissions/${groupId}`, { data });
}

export function fetchGroup(id: GroupId) {
  return Endpoint.get<GroupResponse>(`@makh/groups/group/${id}`);
}

export function createGroup(data: Partial<GroupResponse>) {
  return Endpoint.post<GroupResponse>(`@makh/groups`, { data });
}

export function updateGroup(groupId: GroupId, data: Partial<GroupResponse>) {
  return Endpoint.patch<GroupResponse>(`@makh/groups/${groupId}`, { data });
}

export function deleteGroup(groupId: GroupId) {
  return Endpoint.delete<void>(`@makh/groups/${groupId}`);
}
